/** Limites de caracteres dos campos do checkout (cartão / titular). */
export const CHECKOUT_FIELD_LIMITS = {
  cardHolderName: 100,
  pagadorNome: 100,
  emailContato: 254,
  holderNumber: 10,
  holderAddress: 120,
  holderNeighborhood: 60,
  holderComplement: 60,
  holderState: 2,
  holderCity: 60,
} as const;
